/**
 * Application constants
 */

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const BLUR_LEVELS = {
  low: { pixelSize: 10, label: 'Low Blur' },
  high: { pixelSize: 22, label: 'High Blur' },
  extreme: { pixelSize: 45, label: 'Extreme Blur' }
};

export const STEPS = ['Upload', 'Configure', 'Preview', 'Download'];

// Video workflow has an additional Trim step
export const VIDEO_STEPS = ['Upload', 'Trim', 'Configure', 'Preview', 'Download'];
